import { Link } from "@solidjs/router";
import type { Component } from "solid-js";
import { For } from "solid-js";
import type { Issuer } from "~/trpc/api/issuers";
import Icon from "./Icon";

export const IssuersList: Component<{ issuers: Issuer[] }> = (props) => {
  return (
    <div class="pb-2" style="overflow:auto;">
      <table class="table">
        <thead class="primary-color-bg text-light">
          <tr class="table-row text-center">
            <th class="ps-2 pe-2">Ονομασία</th>
            <th class="ps-2 pe-2">Α.Φ.Μ.</th>
            <th class="ps-2 pe-2">Αρ. Εγκατάστασης</th>
            <th class="ps-2 pe-2">Ενέργειες</th>
          </tr>
        </thead>
        <tbody>
          <For each={props.issuers}>
            {(issuer) => (
              <tr class="table-row text-center">
                <td class="ps-2 pe-2">{issuer.issuerName}</td>
                <td class="ps-2 pe-2">{issuer.vatNumber}</td>
                <td class="ps-2 pe-2">{issuer.branch}</td>
                <td class="ps-2 pe-2">
                  <Link
                    class="btn icon-wrapper p-1 mb-2 mt-2 mobile-small-icon"
                    href={`/dashboard/issuers/${issuer.id}`}
                  >
                    <Icon name="box-arrow-in-right" />
                  </Link>
                  <Link
                    class="btn icon-wrapper p-1 mb-2 mt-2 mobile-small-icon"
                    href={`/dashboard/issuers/${issuer.id}/edit`}
                  >
                    <Icon name="pencil-square" />
                  </Link>
                </td>
              </tr>
            )}
          </For>
        </tbody>
      </table>
    </div>
  );
};

export default IssuersList;
